(() => {
  if (window.__SetTypeScrollToTopInstalled) return;
  window.__SetTypeScrollToTopInstalled = true;

  const FILTERED_EVENT = 'set-type:media-filtered';
  const HEADER_OFFSET = 0; // 0 = media gallery рівно від верху viewport, без відступу під header.
  const FALLBACK_DELAY_MS = 360;
  const AUTO_SCROLL_SETTLE_MS = 1250;
  const SCROLL_START_THRESHOLD = 24;

  let pendingTarget = null;
  let pendingNeedsScroll = false;
  let pendingDecisionActive = false;
  let autoScrollActive = false;
  let fallbackTimer = 0;
  let scrollToken = 0;
  let correctionTimers = [];

  const norm = (s = '') => String(s).replace(/\s+/g, ' ').trim().toLowerCase();

  function isSetTypeName(nameLike = '') {
    return norm(nameLike) === 'set type';
  }

  function extractOptionNameFromNameAttr(nameAttr = '') {
    const n = String(nameAttr || '').trim();
    if (n.startsWith('options[') && n.endsWith(']')) return n.slice(8, -1);
    return '';
  }

  function isSetTypeChangeTarget(el) {
    if (!(el instanceof Element)) return false;

    const fs = el.closest('fieldset');
    if (fs) {
      const legend = fs.querySelector('legend');
      if (legend && isSetTypeName(legend.textContent)) return true;
    }

    const nameAttr = el.getAttribute && el.getAttribute('name') ? el.getAttribute('name') : '';
    if (nameAttr) {
      if (isSetTypeName(nameAttr)) return true;
      const opt = extractOptionNameFromNameAttr(nameAttr);
      if (opt && isSetTypeName(opt)) return true;
    }

    if (el.dataset && el.dataset.optionName && isSetTypeName(el.dataset.optionName)) return true;

    return false;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getGalleryFromEventTarget(target) {
    if (!(target instanceof Element)) return null;
    if (target.tagName === 'MEDIA-GALLERY') return target;
    return target.closest('media-gallery');
  }

  function findMediaTopInSameSection(target) {
    if (!(target instanceof Element)) return null;

    const section = target.closest('.shopify-section, section') || document;
    return (
      section.querySelector('[data-testid="product-information-media"]') ||
      section.querySelector('.product-information__media') ||
      section.querySelector('[data-testid="media-gallery-grid"]') ||
      section.querySelector('media-gallery') ||
      section.querySelector('.product-media-gallery') ||
      section.querySelector('.product-media') ||
      null
    );
  }

  function findMediaTopFromGallery(gallery) {
    if (!(gallery instanceof Element)) return null;

    const section = gallery.closest('.shopify-section, section') || document;
    return findMediaTopInSameSection(section) || gallery;
  }

  function getTopY(target) {
    const rect = target.getBoundingClientRect();
    return Math.max(0, Math.round(window.scrollY + rect.top - HEADER_OFFSET));
  }

  function shouldScrollToMediaTop(target) {
    if (!(target instanceof Element) || !target.isConnected) return false;

    const delta = Math.round(target.getBoundingClientRect().top - HEADER_OFFSET);
    return delta < -SCROLL_START_THRESHOLD;
  }

  function scrollWindowTo(top, behavior) {
    try {
      window.scrollTo({ top, behavior });
    } catch {
      window.scrollTo(0, top);
    }
  }

  function resetHorizontalMediaScroll(target) {
    const gallery =
      target?.tagName === 'MEDIA-GALLERY'
        ? target
        : target?.querySelector?.('media-gallery');

    if (!(gallery instanceof Element)) return;

    const scrollers = gallery.querySelectorAll('slideshow-container, [ref="scroller"]');
    for (let i = 0; i < scrollers.length; i++) {
      const scroller = scrollers[i];
      if (!(scroller instanceof HTMLElement)) continue;
      if (scroller.scrollLeft === 0) continue;

      try {
        scroller.scrollTo({ left: 0, behavior: 'auto' });
      } catch {
        scroller.scrollLeft = 0;
      }
    }
  }

  function clearFallback() {
    if (!fallbackTimer) return;
    window.clearTimeout(fallbackTimer);
    fallbackTimer = 0;
  }

  function clearCorrections() {
    for (let i = 0; i < correctionTimers.length; i++) window.clearTimeout(correctionTimers[i]);
    correctionTimers = [];
  }

  function cancelPendingScroll() {
    pendingTarget = null;
    pendingNeedsScroll = false;
    pendingDecisionActive = false;
    autoScrollActive = false;
    clearFallback();
    clearCorrections();
    scrollToken++;
  }

  function startSmoothScroll(target) {
    if (!(target instanceof Element) || !target.isConnected) return;

    pendingTarget = target;
    clearFallback();
    clearCorrections();
    scrollToken++;

    const token = scrollToken;
    const shouldScroll = pendingDecisionActive ? pendingNeedsScroll : shouldScrollToMediaTop(target);
    pendingNeedsScroll = false;
    pendingDecisionActive = false;

    if (!shouldScroll) {
      autoScrollActive = false;
      return;
    }

    autoScrollActive = true;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (token !== scrollToken) return;
        if (!(pendingTarget instanceof Element) || !pendingTarget.isConnected) return;

        resetHorizontalMediaScroll(pendingTarget);

        const topY = getTopY(pendingTarget);
        const behavior = prefersReducedMotion() ? 'auto' : 'smooth';
        scrollWindowTo(topY, behavior);

        correctionTimers.push(
          window.setTimeout(() => {
            if (token === scrollToken) autoScrollActive = false;
          }, AUTO_SCROLL_SETTLE_MS)
        );
      });
    });
  }

  function scheduleFallback(target) {
    pendingTarget = target;
    clearFallback();

    if (!pendingNeedsScroll) return;

    fallbackTimer = window.setTimeout(() => {
      fallbackTimer = 0;
      if (pendingTarget) startSmoothScroll(pendingTarget);
    }, FALLBACK_DELAY_MS);
  }

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!isSetTypeChangeTarget(target)) return;

      const mediaTop = findMediaTopInSameSection(target);
      if (!mediaTop) return;

      autoScrollActive = false;
      pendingTarget = mediaTop;
      pendingNeedsScroll = shouldScrollToMediaTop(mediaTop);
      pendingDecisionActive = true;

      if (pendingNeedsScroll) {
        scheduleFallback(mediaTop);
      } else {
        cancelPendingScroll();
      }
    },
    true
  );

  document.addEventListener(
    FILTERED_EVENT,
    (event) => {
      const gallery = getGalleryFromEventTarget(event.target);
      const mediaTop = findMediaTopFromGallery(gallery) || pendingTarget;
      if (!mediaTop) return;

      if (autoScrollActive) return;

      if (!pendingDecisionActive || !pendingNeedsScroll) {
        cancelPendingScroll();
        return;
      }

      startSmoothScroll(mediaTop);
    },
    true
  );

  document.addEventListener(
    'touchstart',
    () => {
      if (pendingDecisionActive || autoScrollActive || fallbackTimer || correctionTimers.length) cancelPendingScroll();
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'wheel',
    () => {
      if (pendingDecisionActive || autoScrollActive || fallbackTimer || correctionTimers.length) cancelPendingScroll();
    },
    { passive: true, capture: true }
  );

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (event.pointerType === 'touch') return;
      if (pendingDecisionActive || autoScrollActive || fallbackTimer || correctionTimers.length) cancelPendingScroll();
    },
    true
  );
})();
